import Columns from "../constants/TableColumns";
import SearchCategories from "../constants/SearchCategories";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import useAxios from "../../../../Utils/useAxios";
import updateStatusStafVisibility from "../services/updateStatusStafVisibility";

const StatusStafList = ({ items, resetState, pending }) => {
  
  const axiosInstance = useAxios()

  const toggleActivate = (id) => {
    updateStatusStafVisibility(axiosInstance, id).then(() => {
      resetState()
    })
  }
  
  return (
    <PengaturanListLayout
      items={items}
      itemColumns={Columns(resetState, toggleActivate)}
      searchCategories={SearchCategories}
      pending={pending}
    />
  );
};
export default StatusStafList;
